import styled from "styled-components";
export const CheckboxGroupContainer = styled.div.withConfig({
  displayName: "checkbox-groupstyles__CheckboxGroupContainer",
  componentId: "sc-1vxcq1o-0"
})(["", ""], {
  display: "flex",
  flexDirection: "column",
  marginLeft: "0.5rem"
});
export const CheckboxGroupSelectAllContainer = styled.div.withConfig({
  displayName: "checkbox-groupstyles__CheckboxGroupSelectAllContainer",
  componentId: "sc-1vxcq1o-1"
})(["", ""], {
  marginLeft: "-0.5rem"
});
export const CheckboxGroupContentContainer = styled.div.withConfig({
  displayName: "checkbox-groupstyles__CheckboxGroupContentContainer",
  componentId: "sc-1vxcq1o-2"
})(["", ""], {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  flexWrap: "wrap"
});
export const CheckboxGroupContentItemsContainer = styled.div.withConfig({
  displayName: "checkbox-groupstyles__CheckboxGroupContentItemsContainer",
  componentId: "sc-1vxcq1o-3"
})(["", ""], {
  display: "flex",
  justifyContent: "flex-start",
  flexDirection: "column",
  marginBottom: "1.25rem",
  marginLeft: "0.5rem",
  width: "12rem"
});
